import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { Field, Form, Formik } from "formik";
import { OtpCodeInput } from "components/Form/OtpCodeInput";
import RightPanelHeader from "../../components/rightPanelHeader.component";
import PrimaryButton from "components/Form/Buttons/PrimaryButton";
import { getPathPrefix } from "utils/coreUtils";
import companyUserApi from "services/apis/companyUserApi";
import ToastUtils from "utils/ToastUtils";
import "./ChangePassword.scss";

const ChangePasswordOtp = () => {
  const [t] = useTranslation();
  const [verificationOtp, setVerificationOtp] = React.useState("");
  const navigate = useNavigate();
  // for resend Otp
  const minutes = 0;
  const seconds = 45;
  const [[mins, secs], setTime] = React.useState([minutes, seconds]);
  const [isSendingOtp, setIsSendingOtp] = React.useState(false);
  const initialFormValues = {
    veirfyResetPassOtp: "",
  };
  // for resend Opt
  const tick = () => {
    if (secs > 0) {
      setTime([mins, secs - 1]);
    }
  };
  React.useEffect(() => {
    const timerId = setInterval(() => tick(), 1000);
    return () => clearInterval(timerId);
  }, [mins, secs]);
  const reset = () => setTime([parseInt(minutes), parseInt(seconds)]);
  const resendOtp = async () => {
    setIsSendingOtp(true);
    try {
      await companyUserApi.generateOtpChangePassword({}).then((res) => {
        toast.success(res.data.message);
      });
      reset();
    } catch (error) {
      /* empty */
    }
    setIsSendingOtp(false);
  };
  const handleSubmit = async () => {
    await companyUserApi
      .otpVerificationChangePassword({ otp: verificationOtp })
      .then((res) => {
        if (res.data.status != 200) {
          ToastUtils.serverError(t(`statusCodes.${res?.data?.code}`));
        } else {
          toast.success(t(`statusCodes.${res?.data?.code}`));
        }
        if (res.data.status === "200") {
          navigate(getPathPrefix() + `change-password-reset`, {
            state: { Otp: verificationOtp },
            replace: true,
          });
        }
      });
  };
  return (
    <div className="main-password-change">
      <div className="row bg-white card card-view">
        <div className="form-container">
          <RightPanelHeader
            title={t("otpHints.checkEmailLabel")}
            subTitle={t("otpHints.enterOtpText")}
          />
          <Formik
            initialValues={initialFormValues}
            validateOnMount
            className="mt-2"
            onSubmit={(values) => handleSubmit(values)}
          >
            {({ handleSubmit }) => (
              <Form onSubmit={handleSubmit} className="form-view otp-form">
                <Field
                  render={() => (
                    <OtpCodeInput
                      value={verificationOtp}
                      onValueChange={setVerificationOtp}
                      containerClassName="mb-4"
                    />
                  )}
                  id="veirfyResetPassOtp"
                  name="veirfyResetPassOtp"
                />
                <div className="form-group text-center">
                  {`${secs.toString().padStart(2)}` > 0 ? (
                    <b style={{ color: "#004e5c" }}>
                      {mins.toString().padStart(2, "0")} :{" "}
                      {secs.toString().padStart(2, "0")}
                    </b>
                  ) : isSendingOtp ? (
                    <b className="cursor-pointer">
                      {t("CommonKeys.sendingText")}
                    </b>
                  ) : (
                    <b
                      className="cursor-pointer"
                      onClick={() => {
                        resendOtp();
                      }}
                    >
                      {t("CommonKeys.resendOtpText")}
                    </b>
                  )}
                </div>
                <div className="row justify-content-end mb-3">
                  <PrimaryButton
                    type="submit"
                    title={t("CommonKeys.submitButtonTitle")}
                    className="btn btn-green w-auto w-75"
                  />
                  <PrimaryButton
                    title={t("CommonKeys.cancelButtonTitle")}
                    className="btn btn-green w-auto w-75"
                    onClick={() => {
                      navigate(getPathPrefix("dashboard"), {
                        replace: true,
                      });
                    }}
                  />
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};
export default ChangePasswordOtp;
